export default __webpack_public_path__ + "static/media/pig.f2b290c1.png";